import React, { Component } from "react"
import PropTypes from "prop-types"
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import { ToastContainer } from "react-toastify"
import Highcharts from "highcharts"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
// import "rc-tree/assets/index.css"
import "tablesaw/dist/tablesaw.css"
import "animate.css/source/_base.css"
import "animate.css/source/attention_seekers/wobble.css"
import "./css/pagination/pagination.css"
import * as filterActions from "./state/actions/filterActions"
import * as dashboardApiActions from "./state/actions/dashboardApiActions"
import * as customReportApiActions from "./state/actions/customReportApiActions"
import { MainWrapper, Header, PageWrapper } from "./components/layout"
import TopNav from "./components/layout/navigation/TopNav"
import MobileNav from "./components/layout/navigation/MobileNav"
import { ROUTES } from "./constants"
import actionTypePrefixes from "./state/actions/actionTypePrefixes"
import {
  ActivityAndGeneralStatsDashboard,
  EmployeeEngagementDashboard,
  IntelAndInsightsDashboard,
  PeopleBalanceSheetDashboard,
  PerformanceAndProgressionDashboard,
  CustomReport,
} from "./routes/dashboards"
import { filtersHaveMeaningfulChange } from "./utils/object-utils"
import {
  convertFilterStateToUrlParams,
  convertFilterStateToPostLocations,
} from "./utils/filter-utils"
import { Callback, SignInSilent } from "./routes/auth"

import Error404 from "./routes/errors/Error404"
import "./css/bootstrap/bootstrap.css"
import "./css/material-pro/css/horizontal.css"
import "./css/material-pro/css/theme.css"

class LoggedInApp extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  }

  state = {
    showMobileNav: false,
  }

  componentWillMount = () => {
    // Set the available options in the "View" filter for this user
    this.props.configureViewModeForUser(this.props.userState) // eslint-disable-line react/prop-types
    this.props.loadAvailableFilterListOptions() // eslint-disable-line react/prop-types

    // Configure global chart options
    Highcharts.setOptions({
      lang: {
        thousandsSep: ",",
      },
    })
  }

  componentWillReceiveProps = (nextProps) => {
    // eslint-disable-next-line react/prop-types
    if (filtersHaveMeaningfulChange(this.props.filters, nextProps.filters)) {
      this.loadDashboardData(nextProps.filters)
    }
  }

  /** Loads the current dashboard, then once that has completed,
   * loads all other dashboards simultaneously in the background
   */
  loadDashboardData = (filters) => {
    // Call an action to load the matched dashboard first (priority 1)
    // then all other dashboards in the background to save load times
    // when navigating the frontend dashboards

    // TODO: Ideally we'd be able to cancel API calls already under way on url change too
    // to prevent race conditions - maybe store an axois cancel token per dashboard in redux
    const filtersAsParams = convertFilterStateToUrlParams(filters || this.props.filters)
    const filterLocations = convertFilterStateToPostLocations(filters || this.props.filters)

    const currentUrl = window.location.pathname
    switch (currentUrl) {
      /* eslint-disable react/prop-types */
      case ROUTES.dashboards.activityAndGeneralStats:
        this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
          this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
            this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
              this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
                this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations).then(() => {
                  this.props.loadCustomReport()
                })
              })
            })
          })
        })
        break
      case ROUTES.dashboards.employeeEngagement:
        this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
          this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
            this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
              this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
                this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations).then(() => {
                  this.props.loadCustomReport()
                })
              })
            })
          })
        })
        break
      case ROUTES.dashboards.intelAndInsights:
        this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
          this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
            this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
              this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
                this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations).then(() => {
                  this.props.loadCustomReport()
                })
              })
            })
          })
        })
        break
      case ROUTES.dashboards.peopleBalanceSheet:
        this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
          this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
            this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
              this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
                this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations).then(() => {
                  this.props.loadCustomReport()
                })
              })
            })
          })
        })
        break
      case ROUTES.dashboards.performanceAndProgression:
        this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations).then(() => {
          this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
            this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
              this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
                this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
                  this.props.loadCustomReport()
                })
              })
            })
          })
        })
        break
      case ROUTES.dashboards.customReport:
        this.props.loadCustomReport().then(() => {
          this.props.loadActivityAndGeneralStats(filtersAsParams, filterLocations).then(() => {
            this.props.loadEmployeeEngagement(filtersAsParams, filterLocations).then(() => {
              this.props.loadIntelAndInsights(filtersAsParams, filterLocations).then(() => {
                this.props.loadPeopleBalanceSheet(filtersAsParams, filterLocations).then(() => {
                  this.props.loadPerformanceAndProgression(filtersAsParams, filterLocations)
                })
              })
            })
          })
        })
        break
      default:
        break
    }
  }

  toggleMobileNav = () => {
    this.setState((prevState) => {
      return { showMobileNav: !prevState.showMobileNav }
    })
  }

  render() {
    const { t, userState } = this.props

    let postLoginRoute = ROUTES.dashboards.peopleBalanceSheet

    if (sessionStorage.nextLocation) {
      if (
        sessionStorage.nextLocation !== ROUTES.auth.preLogin &&
        sessionStorage.nextLocation !== ROUTES.auth.signInSilent &&
        sessionStorage.nextLocation.indexOf("/static/") !== 0
      ) {
        postLoginRoute = sessionStorage.nextLocation
      }
      sessionStorage.removeItem("nextLocation")
    }

    const navItems = [
      {
        name: t("Dashboards.Names.PeopleBalanceSheet"),
        route: ROUTES.dashboards.peopleBalanceSheet,
      },
      {
        name: t("Dashboards.Names.EmployeeEngagement"),
        route: ROUTES.dashboards.employeeEngagement,
      },
      { name: t("Dashboards.Names.IntelAndInsights"), route: ROUTES.dashboards.intelAndInsights },
      {
        name: t("Dashboards.Names.PerformanceAndProgression"),
        route: ROUTES.dashboards.performanceAndProgression,
      },
      {
        name: t("Dashboards.Names.ActivityAndGeneralStats"),
        route: ROUTES.dashboards.activityAndGeneralStats,
      },
      {
        name: t("Dashboards.Names.CustomReport"),
        route: ROUTES.dashboards.customReport,
      },
    ]

    return (
      <Router>
        {this.state.showMobileNav ? (
          <MobileNav navItems={navItems} onToggleMobileNav={this.toggleMobileNav} />
        ) : (
          <MainWrapper>
            <Header theme={userState.theme}>
              <TopNav
                navItems={navItems}
                onToggleMobileNav={this.toggleMobileNav}
                theme={userState.theme}
              />
            </Header>
            <PageWrapper>
              <ToastContainer />
              <Switch>
                <Redirect exact from="/" to={ROUTES.dashboards.peopleBalanceSheet} />
                <Redirect exact from="/dashboard" to={ROUTES.dashboards.peopleBalanceSheet} />
                <Redirect exact from="/dashboard/" to={ROUTES.dashboards.peopleBalanceSheet} />
                <Redirect exact from="/auth/pre-login" to={postLoginRoute} />
                <Route
                  exact
                  path={ROUTES.dashboards.peopleBalanceSheet}
                  render={props => (
                    <PeopleBalanceSheetDashboard
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />

                <Route
                  exact
                  path={ROUTES.dashboards.employeeEngagement}
                  render={props => (
                    <EmployeeEngagementDashboard
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />

                <Route
                  exact
                  path={ROUTES.dashboards.intelAndInsights}
                  render={props => (
                    <IntelAndInsightsDashboard
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />

                <Route
                  exact
                  path={ROUTES.dashboards.performanceAndProgression}
                  render={props => (
                    <PerformanceAndProgressionDashboard
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />

                <Route
                  exact
                  path={ROUTES.dashboards.activityAndGeneralStats}
                  render={props => (
                    <ActivityAndGeneralStatsDashboard
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.dashboards.customReport}
                  render={props => (
                    <CustomReport
                      onReload={() => this.loadDashboardData(this.props.filters)}
                      {...props}
                    />
                  )}
                />
                <Route path={ROUTES.auth.callback} component={Callback} />
                <Route path={ROUTES.auth.signInSilent} component={SignInSilent} />
                <Route component={Error404} />
              </Switch>
            </PageWrapper>
            <div id="end-of-body" />
          </MainWrapper>
        )}
      </Router>
    )
  }
}

function mapStateToProps(state) {
  return {
    userState: state.userDetail,
    filters: state.filters,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    configureViewModeForUser: user => dispatch(filterActions.configureViewModeForUser(user)),
    loadAvailableFilterListOptions: () => dispatch(filterActions.loadAvailableFilterListOptions()),

    loadActivityAndGeneralStats: (filtersAsParams, filterLocations) =>
      dispatch(dashboardApiActions.loadDashboardData(
        actionTypePrefixes.ActivityAndGeneralStats,
        filtersAsParams,
        filterLocations
      )),
    loadEmployeeEngagement: (filtersAsParams, filterLocations) =>
      dispatch(dashboardApiActions.loadDashboardData(
        actionTypePrefixes.EmployeeEngagement,
        filtersAsParams,
        filterLocations
      )),
    loadIntelAndInsights: (filtersAsParams, filterLocations) =>
      dispatch(dashboardApiActions.loadDashboardData(
        actionTypePrefixes.IntelAndInsights,
        filtersAsParams,
        filterLocations
      )),
    loadPeopleBalanceSheet: (filtersAsParams, filterLocations) =>
      dispatch(dashboardApiActions.loadDashboardData(
        actionTypePrefixes.PeopleBalanceSheet,
        filtersAsParams,
        filterLocations
      )),
    loadPerformanceAndProgression: (filtersAsParams, filterLocations) =>
      dispatch(dashboardApiActions.loadDashboardData(
        actionTypePrefixes.PerformanceAndProgression,
        filtersAsParams,
        filterLocations
      )),
    loadCustomReport: () =>
      dispatch(customReportApiActions.loadDashboardData()),
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(LoggedInApp)



// WEBPACK FOOTER //
// ./src/LoggedInApp.jsx